import { render, staticRenderFns } from "./DynamicAttributeConfigurationSluggable.vue?vue&type=template&id=163c1a1e&"
import script from "./DynamicAttributeConfigurationSluggable.vue?vue&type=script&lang=ts&"
export * from "./DynamicAttributeConfigurationSluggable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports